export enum ERoutesPrivate {
    Admins,
    Users,
    Dashboard,
    Transactions,
    Complaints,
    Withdraws,
    PendingTasks,
    TwoFA,
    EKYC,
    Screenings,
    AdminActivityLog,
    UserActivityLog,
}

export enum ERoutesPublic {
    SignIn,
}

export enum ERoutesType {
    Private,
    Public,
}

export const routes = {
    [ERoutesType.Private]: {
        [ERoutesPrivate.Admins]: ['/admins'],
        [ERoutesPrivate.Users]: ['/users'],
        [ERoutesPrivate.Dashboard]: ['/dashboard'],
        [ERoutesPrivate.Transactions]: ['/transactions'],
        [ERoutesPrivate.Complaints]: ['/complaints'],
        [ERoutesPrivate.Withdraws]: ['/withdraws'],
        [ERoutesPrivate.PendingTasks]: ['/pending-tasks'],
        [ERoutesPrivate.TwoFA]: ['/two-fa'],
        [ERoutesPrivate.EKYC]: ['/kyc'],
        [ERoutesPrivate.Screenings]: ['/screenings'],
        [ERoutesPrivate.AdminActivityLog]: ['/admin-activity-log'],
        [ERoutesPrivate.UserActivityLog]: ['/user-activity-log'],
    },
    [ERoutesType.Public]: {
        [ERoutesPublic.SignIn]: ['/sign-in'],
    },
};
